import * as React from 'react';
import { Button, Column, DataTable } from 'primereact';
import { TabView, TabPanel } from 'primereact/tabview';
import axios from 'axios';
import URLUtils, { getAppNameFromPath } from '../utilities/URLUtils';
import SessionStorageService from '../services/SessionStorageService';
import { SpinnerComponent } from '../commonComponent/SpinnerComponent';
import { parseJson } from '../utilities/JsonUtils';
import { TOKEN_TYPE } from '../entities/Constants';

interface Props {
    callback
}

interface State {
    MyFormList;
    AllFormList;
    TemplateList;
    activeIndex: number,
    isBusy:boolean
}

export class ListFormComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            MyFormList: [],
            AllFormList: [],
            TemplateList: [],
            activeIndex: 0,
            isBusy:false
        };
    }

    getlist=()=>{
        let api = URLUtils.concatUrls('data/admin/my-form');
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }
        this.setState({isBusy:true})
        axios.get(api, {headers:headers}).then(
            (response) => {
            //    let myUserId = SessionStorageService.getUserId().toLowerCase();
                this.setState({isBusy:false})
            //    console.log(response.data);
            //    let myFormList = response.data.filter((form) => form.createdById.toLowerCase()==myUserId || this.userIsCoOwner(form.attachment, form.categoryId));
                this.setState({ MyFormList: response.data });
            }
        )
    }
    componentDidMount = () => {
        this.getlist();
        
    }

    userIsCoOwner = (attachment: string, categoryId: string) => {
        let myUserId = SessionStorageService.getUserId().toLowerCase();
        let usersList = parseJson(attachment, categoryId).Coowners;
        if (usersList == null) { return false }
        return usersList.find((user) => user.email.toLowerCase() == myUserId)
    }
    setActiveIndex = (index) => {
   
        this.setState({ activeIndex: index })
        switch (index){
            case 0:{
                let api = URLUtils.concatUrls('data/admin/all-form');
                const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                const headers = {
                    'Authorization': `Bearer ${token}`
                }
                this.setState({isBusy:true})
                axios.get(api, {headers:headers}).then(
                    (response) => {
                        console.log(response.data);
                        let myUserId = SessionStorageService.getUserId().toLowerCase();
                        console.log(myUserId);
                        console.log(response.data)
                        let myFormList = response.data.filter((form) => form.createdById.toLowerCase()==myUserId || this.userIsCoOwner(form.attachment, form.categoryId));
                        this.setState({ MyFormList: myFormList, isBusy:false });
                    }
                )
            }
            case 1: {
                let api = URLUtils.concatUrls('data/admin/all-form');
                const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                const headers = {
                    'Authorization': `Bearer ${token}`
                }
                this.setState({isBusy:true})
                axios.get(api, {headers:headers}).then(
                    (response) => {
                        this.setState({ AllFormList: response.data, isBusy:false });
                    }
                );
                break;
            }
            case 2 :{
                let api = URLUtils.concatUrls('data/admin/all-template');
                const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                const headers = {
                    'Authorization': `Bearer ${token}`
                }
                this.setState({isBusy:true})
                axios.get(api, {headers:headers}).then(
                    (response) => {
                        this.setState({ TemplateList: response.data, isBusy:false });
                    }
                )
            }
        }
    }

    inputTemplate = (rowData) => {
        return (new Date(rowData.createdDate)).toLocaleString();
    }
    inputTemplateUpdate = (rowData) => {
        return (new Date(rowData.updatedDate)).toLocaleString();
    }
    render() {
        let addButton = <Button
                key={'BtnAdd_'}
                label={"Create New Form"}
                onClick={(e) => {
                    this.props.callback()
                }}
            />;

        let header = (
            <div key={'fdHeader_div_'} style={{ textAlign: 'center' }} >
                {addButton}
            </div>
        );

        return (
            <>
                <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setActiveIndex(e.index)}>
                    <TabPanel header="My Forms">
                        <DataTable resizableColumns value={this.state.MyFormList} header={header} showGridlines selectionMode="single" key="id" onSelectionChange={e => this.props.callback(e.value)} >
                            {/* <Column field="id" style={{ width: '6%' }} header="ID"></Column> */}
                            <Column field="categoryId" style={{ width: '20%' }} header="Application ID"></Column>
                            <Column field="categoryName" style={{ width: '20%' }} header="Application Name"></Column>
                            {/* <Column field="reportbackType" style={{ width: '20%' }} header="Report Back Type"></Column>
    <Column field="reportbackName" style={{ width: '20%' }} header="Report Back Name"></Column> */}
                            <Column body={this.inputTemplate} style={{ width: '13%' }} header="Created On"></Column>
                            <Column field="userName" style={{ width: '12%' }} header="Created By"></Column>
                            <Column body={this.inputTemplateUpdate} style={{ width: '14%' }} header="Updated On"></Column>
                            <Column field="userUpdateName" style={{ width: '12%' }} header="Updated By"></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="All Forms">
                        <DataTable value={this.state.AllFormList}  showGridlines selectionMode="single" onSelectionChange={e => this.props.callback(e.value)} >
                        <Column field="categoryId" style={{ width: '10%' }} header="Application ID"></Column> 
                            <Column field="categoryName" style={{ width: '20%' }} header="Application Name"></Column>
                            {/* <Column field="reportbackType" style={{ width: '20%' }} header="Report Back Type"></Column>
                            <Column field="reportbackName" style={{ width: '20%' }} header="Report Back Name"></Column> */}
                            <Column body={this.inputTemplate} style={{ width: '13%' }} header="Created On"></Column>
                            <Column field="userName" style={{ width: '12%' }} header="Created By"></Column>
                            <Column body={this.inputTemplateUpdate} style={{ width: '14%' }} header="Updated On"></Column>
                            <Column field="userUpdateName" style={{ width: '12%' }} header="Updated By"></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="All Templates">
                        <DataTable value={this.state.TemplateList} showGridlines>
                            <Column field="id" style={{ width: '6%' }} header="ID"></Column>
                            <Column field="categoryName" style={{ width: '62%' }} header="Template Name"></Column>
                            <Column body={this.inputTemplate} style={{ width: '18%' }} header="Created On"></Column>
                            <Column field="userName" style={{ width: '14%' }} header="Created By"></Column>
                            <Column body={this.inputTemplateUpdate} style={{ width: '14%' }} header="Updated On"></Column>
                            <Column field="userUpdateName" style={{ width: '12%' }} header="Updated By"></Column>
                        </DataTable>
                    </TabPanel>
                </TabView>
                <div>
                    <SpinnerComponent isBusy={this.state.isBusy} />
                </div>
            </>
            
        )
    }

}